import { Playground, Props } from 'docz';
import Button from '@redoute/button';
import * as React from 'react';
export default {
  Playground,
  Props,
  Button,
  React
};